import * as React from "react";
import { Translate } from "react-localize-redux";
import jumbotron from "../assets/banner.jpg";
import "./Jumbotron.scss";

interface IProps {
  onPreviousOffer?: any;
}
class Jumbotron extends React.Component<IProps, {}> {
  private jumbotronStyle = {
    backgroundImage: `url(${jumbotron})`,
    backgroundPosition: "50% 50%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    border: "1 px solid red"
  };
  private jumbotronStylEmbed = {
    backgroundImage: `url(${jumbotron})`,
    backgroundPosition: "50% 50%",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    border: "1 px solid red",
    height: "180px"
  };

  constructor(props: IProps) {
    super(props);

    this.handleExistingClick = this.handleExistingClick.bind(this);
  }

  public render() {
    if (process.env.REACT_APP_FE_MODE === "embed") {
      return (
        <div className="jumbotron jumbotron-fluid" style={this.jumbotronStylEmbed}>
          <div className="container">
            <div>
              <h1>
                <Translate id="SOP" />
              </h1>
              <span className="text-secondary">
                <Translate id="EmbedDisclaimer" />
              </span>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="jumbotron jumbotron-fluid" style={this.jumbotronStyle}>
          <div className="container">
            <div className="d-none d-md-block text-right">
              <button className={"btn btn-primary " + (!this.props.onPreviousOffer ? "invisible" : "")} onClick={this.handleExistingClick}>
                <span className="d-flex text-right">
                  <Translate id="EditExistingOffer" />
                </span>
              </button>
            </div>
            <div className="my-5">
              <h6 className="d-none d-md-block text-uppercase">Netvisor</h6>
              <h1 className="display-4">
                <Translate id="SOP" />
              </h1>
            </div>
          </div>
        </div>
      );
    }
  }

  private handleExistingClick() {
    if (typeof this.props.onPreviousOffer === "function") {
      this.props.onPreviousOffer();
    }
  }
}

export default Jumbotron;
